<template>
  <div class="curriculum-management" v-if="courseList">
    <!-- v-bitmap="getListResult" -->
    <!-- 选择班级 -->
    <div class="select-class">
      <div class="select-c">
        <!-- 请选择班级： -->
        <el-cascader v-show="classScheduleType == '手动排课'" v-model="className" :placeholder="classPlaceholder"
          :props="classProps" :options="classSelect" @change="changeHandle"></el-cascader>
        <!-- <el-button style="margin-left: 20px;" v-show="classScheduleType == '手动排课'" type="success" round
          @click="exportCourseArrangeByClass">导出课程表</el-button> -->
        <el-select v-show="classScheduleType == '智慧排课' && autoMaticallyScheduleClassStatus
          " v-model="gradeValue" placeholder="请选择年级" @change="selectGrade">
          <el-option v-for="item in classSelectList" :key="item.gradeId" :label="item.gradeName" :value="item.gradeId">
          </el-option>
        </el-select>
        <!-- <el-button style="margin-left: 20px;" v-show="autoMaticList.length && classScheduleType == '智慧排课'"
          type="success" round @click="exportCourseArrangeByGrade">导出课程表</el-button> -->
        <!-- <el-select v-show="classScheduleType == '我的课表' && myClassScheduleList.length" v-model="myClassScheduleSelectId"
          placeholder="请选择年级" @change="myClassScheduleSelect">
          <el-option v-for="item in myClassScheduleList" :key="item.classId" :label="item.gradeName + item.className"
            :value="item.classId">
          </el-option>
        </el-select> -->
        <span style="margin-left: 20px" v-show="classScheduleType == '智慧排课'">最大课节数： {{ courseConstructionNum }}</span>
      </div>
      <div class="btns">
        <!-- 智慧排课重新排课 -->
        <el-button style="margin-right: 10px;" v-show="autoMaticallyScheduleClassStatus && classScheduleType == '智慧排课'"
          size="medium" @click="classRearrange" type="warning" v-hasPermi="'sc:coursearrange:edit'">
          重新排课
        </el-button>
        <!-- 班级课表导出 -->
        <el-button v-show="classScheduleType == '手动排课'" v-hasPermi="'sc:class:schedule:export'"
          style="margin-right: 10px;" type="success" size="medium" @click="exportCourseArrange">导出课表</el-button>
        <!-- 年级排课导出 -->
        <el-button v-show="classScheduleType == '智慧排课'" v-hasPermi="'sc:grade:schedule:export'"
          style="margin-right: 10px; margin-left: 0;" type="success" size="medium"
          @click="exportCourseArrange">导出课表</el-button>
        <!-- 我的课表导出 -->
        <el-button v-show="classScheduleType == '我的课表'" v-hasPermi="'sc:myself:schedule:export'"
          style="margin-right: 10px;" type="success" size="medium" @click="exportCourseArrange">导出课表</el-button>
        <!-- 班级课表删除 -->
        <el-button v-hasPermi="'sc:coursearrange:delete'" v-show="classScheduleType == '手动排课'" style="margin-right: 10px; margin-left: 0;" type="danger"
          size="medium" @click="delCourseArrange">删除课表</el-button>
        <!-- 年级排课删除 -->
        <el-button v-hasPermi="'sc:coursearrange:delete'" v-show="classScheduleType == '智慧排课'" style="margin-right: 10px; margin-left: 0;" type="danger"
          size="medium" @click="delCourseArrange">删除课表</el-button>
        <el-radio-group v-model="classScheduleType" size="medium" fill="#409eff" @input="classScheduleTypeSelect">
          <el-radio-button label="手动排课" class="radio-btn"></el-radio-button>
          <el-radio-button label="智慧排课" class="radio-btn" v-hasPermi="'sc:coursearrange:edit'"></el-radio-button>
          <el-radio-button label="我的课表" class="radio-btn"></el-radio-button>
          <!-- v-hasPermi="'sc:coursearrange:myself'" -->
        </el-radio-group>
      </div>
    </div>
    <!-- 手动排课 -->
    <manualScheduling ref="manualScheduling" v-show="classScheduleType == '手动排课'" v-bitmap="getListResult"
      :classId="classId" :tableShow="tableShow" :courseList="courseList" :courseModuleList="courseModuleList"
      :isComebackButtonShow="isComebackButtonShow" :isGetCurriculumTableSuccess="isGetCurriculumTableSuccess"
      :isCourseModuleListLoading="isCourseModuleListLoading" :curriculumShow="curriculumShow"
      :autoMaticListByClass="autoMaticListByClass" :className="className" :setState="setState"
      @setCourseListAgain="setCourseListAgain" @isStepShowChange="isStepShowChange" @weekLabelWidth="weekLabelWidth"
      @editCourseTeacherConfirm="editCourseTeacherConfirm" />
    <!-- 智慧排课 -->
    <automaticCourseScheduling v-show="!autoMaticList.length && classScheduleType == '智慧排课'" :courseList="courseList"
      :schoolClassList="schoolClassList" :classroomList="classroomList" :courseConstructionNum="courseConstructionNum"
      :coursePlanDailyMaxNum="coursePlanDailyMaxNum" :gradeSelect="gradeSelect"
      :autoMaticCourseList="autoMaticCourseList" :isCourseModuleListLoading="isCourseModuleListLoading"
      :isComebackButtonShow="isComebackButtonShow" :teacherList="teacherList" @reset="reset"
      @setCourseListAgain="setCourseListAgain" @automaticCourseScheduling="automaticCourseScheduling"
      @schoolClassListRead="schoolClassListRead" />
    <!-- 年级排课 -->
    <gradeSchedule v-show="autoMaticList.length && classScheduleType == '智慧排课'"
      :autoMaticallyScheduleClassStatus="autoMaticallyScheduleClassStatus" :gradeSelect="gradeSelect"
      :autoMaticList="autoMaticList" :courseConstructionNum="courseConstructionNum"
      :weekLabelWidthVal="weekLabelWidthVal" :messagesShow="messagesShow" :messagesArray="messagesArray"
      @classRearrange="classRearrange" @automaticCourseScheduling="automaticCourseScheduling"
      @autoMaticallyScheduleClassStatusChange="autoMaticallyScheduleClassStatusChange
        " />
    <myClassSchedule v-show="classScheduleType == '我的课表'" :courseList="courseList"
      :myClassScheduleSelectData="myClassScheduleSelectData"
      :myClassScheduleSelectHeaders="myClassScheduleSelectHeaders" />

    <el-dialog title="提示" :visible.sync="messagesDialogShow" width="50%" height="200px" center>
      <div style="max-height: 400px; overflow-y: auto">
        <p style="font-size: 18px; margin-bottom: 8px" v-for="(item, index) in messagesArray" :key="index">
          {{ index + 1 }}.&nbsp;&nbsp;{{ item }}
        </p>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="messagesDialogShow = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import manualScheduling from "../manual-scheduling/manual-scheduling.vue";
import automaticCourseScheduling from "../automatic-course-scheduling/automatic-course-scheduling.vue";
import myClassSchedule from "../my-class-schedule/my-class-schedule.vue";
import gradeSchedule from "../grade-schedule/grade-schedule.vue";
import { v4 as uuidv4 } from "uuid";
import { baseURL } from "@/api/request"; // 服务器地址
export default {
  components: {
    manualScheduling,
    automaticCourseScheduling,
    myClassSchedule,
    gradeSchedule,
  },
  data() {
    return {
      //科目模块列表loading开关
      isCourseModuleListLoading: false,
      //科目模块列表
      courseModuleList: [],
      //返回到第一步的按钮显示开关
      isComebackButtonShow: false,
      //发布按钮是否禁用
      isGetCurriculumTableSuccess: false,
      // 处理后的班级年级多选数据
      classSelect: [],
      // 级联选择器属性配置
      classProps: {
        expandTrigger: "hover",
        children: "schoolClassList",
      },
      // 选中后的班级年级
      className: [],
      // 班级年级数据
      classSelectList: [],
      // 默认classId，用于第一次请求
      classId: "",
      tableShow: true,
      getListResult: "success",
      // 选择班级提示文字
      classPlaceholder: "",
      // 选中班级数据
      currentClassInfo: [],
      // 课程表获取报错时不显示操作用到
      curriculumShow: true,
      // 课表类型
      classScheduleType: "手动排课",
      // 智慧排课-年级选择
      gradeValue: "",
      // 选中年级对应的班级列表
      schoolClassList: [],
      // 学校课室列表
      classroomList: [],
      // 教师列表
      teacherList: [],
      courseSelectList: [],
      // 智慧排课-最大课时数
      courseConstructionNum: 0,
      // 年级每天最大课节
      coursePlanDailyMaxNum: 0,
      gradeSelect: null,
      // 自动排课科目显示
      autoMaticCourseList: [],
      // 排课表数据
      autoMaticList: [],
      // 自动排课状态
      autoMaticallyScheduleClassStatus: true,
      // 手动排课课表
      autoMaticListByClass: [],
      // 上一级传来的科目列表
      previousLevelSubjectsList: [],
      // 我的课表数据
      // myClassScheduleList: [],
      // 我的课表选中内容数据
      // myClassScheduleSelectId: "",
      myClassScheduleSelectData: null,
      myClassScheduleSelectHeaders: null,
      weekLabelWidthVal: 0,
      messagesArray: [],
      messagesDialogShow: false,
      messagesShow: false,
      setState: true, // 手动排课保存按钮显示
    };
  },
  props: {
    //第二步选择完成的科目模块列表数据
    courseList: {
      type: Array,
    },
    isStepShow: {
      type: Boolean,
    },
    currentClass: {
      type: [Array, String],
      default: () => [],
    },
  },
  created() {
    // 获取课室列表
    this.getClassroomList();
    // 获取智慧排课时要使用到的科目列表
    this.getCourseList();
  },
  mounted() {
    // 上一级传来的科目列表
    this.previousLevelSubjectsList = this.courseList;
    if (this.courseList.length) {
      // 重新编排回来时选回之前选中的班级
      this.currentClassInfo = this.currentClass;
      this.className = this.currentClass;
      this.gradeValue = this.currentClass[0].gradeId;
      this.classId = this.currentClass[1].classId;
      // 默认选中班级显示文字
      this.classPlaceholder = `${this.currentClass[0].gradeName} / ${this.currentClass[1].className}`;
      // 如果courseList有数据就是从第一，二步过来的，将数据赋予courseModuleList
      // 如果courseList没数据就是一开始就在第三步，获取科目模块列表与课程表数据
      // 重新编排按钮显示开关
      this.isComebackButtonShow = true;
      // 发布按钮是否禁用
      this.isGetCurriculumTableSuccess = true;
      // 获取课表信息-班级-手动排课
      this.selectCourseArrangeListByClass();
      // 科目数据格式转换
      this.previousLevelSubjectsList.forEach((item) => {
        this.courseModuleList.push({
          classroomId: item.classroomId,
          classroomName: item.classroomName,
          courseId: item.courseId,
          courseName: item.courseName,
          lessonsContent: item.courseName,
          scheduleState: "1",
          teacherId: item.teacherId,
          teacherName: item.teacherName,
          teacherNumber: item.teacherNumber,
        });
      });
    }
    // 班级年级数据获取
    this.selectSchoolAndGradeAndClassListPC();
  },
  methods: {
    // 修改科任老师-手动排课
    editCourseTeacherConfirm(data) {
      this.put(this.$url.updateCourseArrangeTeacher, data).then(res => {
        if (res.code !== 200) return this.$message.error(res.msg);
        this.$refs.manualScheduling.isCheckedLessonDetailDialogShow = false;
        this.$message.success(res.msg);
        this.selectCourseArrangeListByClass();
      })
    },
    // 课表删除点击
    delCourseArrange() {
      this.$confirm("确定删除该课表吗？", "删除课表", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      }).then(() => {
        let data = {};
        // 根据不同的分类传递不同的参数
        if (this.classScheduleType == "手动排课") {
          data = {
            "gradeId": this.gradeValue,
            "classId": this.classId
          };
        } else if (this.classScheduleType == "智慧排课") {
          data = {
            "gradeId": this.gradeValue,
          };
        };
        this.delete(this.$url.deleteCourseArrangeList, data).then(res => {
          if (res.code !== 200) return this.$message.error(res.msg);
          this.$message.success(res.msg);
          // 删除完成重新获取课表信息
          if (this.classScheduleType == "手动排课") {
            this.selectCourseArrangeListByClass();
          } else if (this.classScheduleType == "智慧排课") {
            this.selectCourseArrangeList();
          };
        })
      })
    },
    async schoolClassListRead(data) {
      // 切换年级重新获取当前年级的教师列表
      for (let item of data) {
        item["teacherList"] = await this.getTeacherList(item.classId);
      };
      this.schoolClassList = data;
    },
    // 导出课表点击
    exportCourseArrange() {
      if (this.classScheduleType == "手动排课") {
        this.exportCourseArrangeByClass();
      } else if (this.classScheduleType == "智慧排课") {
        this.exportCourseArrangeByGrade();
      } else {
        this.exportCourseArrangeByMySelf();
      }
    },
    // 我的排课导出
    exportCourseArrangeByMySelf() {
      let action = `${baseURL}${this.$url.exportCourseArrangeByMySelf}?teacherId=${this.user.id}`;
      window.location.href = action;
    },
    // 班级课表导出
    exportCourseArrangeByClass() {
      let action = `${baseURL}${this.$url.exportCourseArrangeByClass}?gradeId=${this.gradeValue}&classId=${this.classId}`;
      window.location.href = action;
    },
    // 年级排课导出
    exportCourseArrangeByGrade() {
      let action = `${baseURL}${this.$url.exportCourseArrangeByGrade}?gradeId=${this.gradeValue}`;
      window.location.href = action;
    },
    // 课表星期宽度
    weekLabelWidth(e) {
      this.weekLabelWidthVal = e;
    },
    // 保存课表刷新
    autoMaticallyScheduleClassStatusChange(e) {
      this.autoMaticallyScheduleClassStatus = e;
      this.messagesArray = [];
      this.messagesShow = false;
    },
    // 顶部步骤切换显示-保存时取消显示
    isStepShowChange(e) {
      this.$emit("isStepShowChange", e);
    },
    // 我的课表左上角选中切换
    // myClassScheduleSelect(e) {
    //   this.myClassScheduleSelectData = this.myClassScheduleList.find(
    //     (item) => item.classId == e
    //   ).scheduleList;
    // },
    // 获取我的课表
    selectCourseArrangeByTeacher() {
      let data = {
        teacherId: this.user.id,
      };
      this.post(this.$url.selectCourseArrangeByTeacher, data).then((res) => {
        // console.log("获取我的课表==>", res);
        if (res.code !== 200 || !res.data.length) {
          this.$message.warning("暂无课程编排");
          this.setState = false;
          return;
        }
        this.setState = true;
        res.data.map(row => row.map(item => item === null ? '' : item));
        // 分离表头和内容
        this.myClassScheduleSelectHeaders = res.data[0];
        this.myClassScheduleSelectData = res.data.slice(1);
        // this.myClassScheduleList = res.data;
        // this.myClassScheduleSelectId = res.data[0].classId;
        // this.myClassScheduleSelectData = this.myClassScheduleList.find(
        //   (item) => item.classId == res.data[0].classId
        // ).scheduleList;
      });
    },
    // 智慧排课中点击重新排课
    classRearrange() {
      if (this.courseConstructionNum == 0)
        return this.$message.warning("暂无课时，请前往课程计划设置！");
      this.autoMaticList = [];
      // this.selectCourseArrangeList();
    },
    // 获取课表信息-年级-智慧排课
    selectCourseArrangeList() {
      // 获取当前年级id
      let data = {
        gradeId: this.gradeValue
      };
      this.post(this.$url.selectCourseArrangeList, data).then((res) => {
        // console.log("获取年级课表信息==>", res);
        if (res.code !== 200) return this.$message.error(res.msg);
        this.autoMaticList = res.data.map((item, index) => {
          const backgroundColor = this.generateRandomHexColor(index);

          return {
            ...item,
            backgroundColor,
            scheduleList: item.scheduleList.map((fItem) => {
              return {
                ...fItem,
                lessons: fItem.lessons.map((lItem) => {
                  return {
                    ...lItem,
                    classCode: item.classCode,
                    classId: item.classId,
                    className: item.className,
                    backgroundColor,
                  };
                }),
              };
            }),
          };
        });

        // console.log("this.autoMaticList:", this.autoMaticList);
      });
    },
    // 获取课表信息-班级-手动排课
    selectCourseArrangeListByClass() {
      // 获取当前年级id
      let data = {
        classId: this.classId,
        gradeId: this.gradeValue,
      };
      // 假设星期从1到7，分别表示周一到周日
      const daysOfWeek = [1, 2, 3, 4, 5, 6, 7];
      this.post(this.$url.selectCourseArrangeList, data)
        .then((res) => {
          // console.log("获取班级课表信息==>", res);
          if (res.code != 200) {
            this.tableShow = false;
            this.curriculumShow = false;
            this.isGetCurriculumTableSuccess = false;
            this.getListResult = "error";
            return this.$message.error(res.msg);
          }

          this.tableShow = res.data[0].scheduleList.length == 0 ? false : true;

          this.getListResult =
            res.data[0].scheduleList.length == 0 ? "nullData" : "success";
          // console.log("this.getListResult:", this.getListResult);
          if (!this.tableShow)
            return this.$message.warning("请先前往设置课程计划！");

          // 补全星期后按星期数字排序
          res.data[0].scheduleList.forEach((item) => {
            item["id"] = uuidv4();

            // 补齐星期的逻辑
            daysOfWeek.map((day) => {
              const existingDetail = item.lessons.find(
                (detail) => detail.week === day
              );

              if (!existingDetail) {
                item.lessons.push({
                  classroomId: "",
                  classroomName: "",
                  courseId: "",
                  courseName: "",
                  lessonsContent: "",
                  scheduleState: "1",
                  teacherId: "",
                  teacherName: "",
                  teacherNumber: "",
                  week: day,
                });
              }
            });

            // 按星期数字排序
            item.lessons.sort((a, b) => {
              const weekA = daysOfWeek.indexOf(a.week);
              const weekB = daysOfWeek.indexOf(b.week);

              return weekA - weekB;
            });
          });

          let tableData = res.data[0];
          this.autoMaticListByClass = res.data[0];

          if (this.previousLevelSubjectsList.length == 0) {
            this.courseModuleList = this.extractCoursesWithScheduleStateOne(
              tableData.scheduleList
            );

            //科目模块列表没有数据，说明没有进行过课程编排，回到第一步
            if (!this.courseModuleList.length) {
              this.$message.warning("暂无课程编排");
              this.setState = false;
              // this.$emit("currentUserNotSetCurriculumTable");
              // this.$emit("changeEstablish", this.className);
            } else {
              this.setState = true;
            }
          }
          // console.log("科目列表数据==>", this.courseModuleList);
          // console.log("手动排课班级课程表==>", this.autoMaticListByClass);

          //显示重新编辑科目按钮
          this.isComebackButtonShow = true;
          this.isGetCurriculumTableSuccess = true;
        })
        .catch((err) => {
          console.log("获取手动排课班级课程表报错==>", err);
        });
    },
    // 课程表数据转换
    extractCoursesWithScheduleStateOne(scheduleData) {
      // console.log("scheduleData:", scheduleData);
      const courseModuleList = [];

      scheduleData.forEach((grade) => {
        grade.lessons.forEach((course) => {
          if (
            course.scheduleState === "1" &&
            course.lessonsContent !== "" &&
            course.lessonsContent
          ) {
            const existingCourse = courseModuleList.find(
              (item) => item.lessonsContent === course.lessonsContent
            );

            if (!existingCourse) {
              courseModuleList.push({
                classroomId: course.classroomId,
                classroomName: course.classroomName,
                courseId: course.courseId,
                courseName: course.lessonsContent,
                lessonsContent: course.lessonsContent,
                scheduleState: course.scheduleState,
                teacherId: course.teacherId,
                teacherName: course.teacherName,
                teacherNumber: course.teacherNumber,
              });
            }
          }
        });
      });

      return courseModuleList;
    },
    // 自动排课生成
    automaticCourseScheduling(e) {
      // this.reset();
      if (e.code !== 200) return this.$message.error("生成失败");
      // this.autoMaticallyScheduleClassStatus = e.msg == "[]" ? true : false;
      this.messagesArray = [];
      this.autoMaticallyScheduleClassStatus = false;
      this.autoMaticList = e.data ? e.data : [];

      this.autoMaticList = this.autoMaticList.map((item, index) => {
        const backgroundColor = this.generateRandomHexColor(index);

        return {
          ...item,
          backgroundColor,
          scheduleList: item.scheduleList.map((fItem) => {
            return {
              ...fItem,
              lessons: fItem.lessons.map((lItem) => {
                return {
                  ...lItem,
                  classCode: item.classCode,
                  classId: item.classId,
                  className: item.className,
                  backgroundColor: lItem.issueLessons == 1 ? '#f46363' : backgroundColor,
                };
              }),
            };
          }),
        };
      });

      // console.log(" this.autoMaticList:",  this.autoMaticList);

      if (e.msg !== "[]") {
        // 将字符串转换为数组
        // const messagesArray = JSON.parse(e.msg);

        this.messagesArray = JSON.parse(e.msg);
        this.messagesShow = true;
        if (e.data) return;
        this.messagesDialogShow = true;
        // 遍历数组并使用 Element UI 的消息提示
        // let index = 0;

        // const intervalId = setInterval(() => {
        //   if (index < messagesArray.length) {
        //     // this.$message.error(messagesArray[index]);
        //     this.$message({
        //       showClose: true,
        //       message: messagesArray[index],
        //       type: "warning",
        //       duration: 10000,
        //     });
        //     index++;
        //   } else {
        //     clearInterval(intervalId); // 当所有消息都显示完毕后清除定时器
        //   }
        // }, 1000);
      } else {
        // this.$message.success("生成成功");
      }
    },
    // 获取学校所有科目-自动排课显示用
    getCourseList() {
      this.get(this.$url.getCourseList, {
        schoolId: this.user.schoolId,
        courseType: 0
      }).then((res) => {
        if (res.rows === null) {
          return this.$message.warning(
            "暂无设置科目，请前往科目管理添加科目！"
          );
        }
        if (res.code != 200) {
          return this.$message.error("获取科目列表失败！");
        }
        const curseListData = res.rows;
        curseListData.forEach((item) => {
          this.autoMaticCourseList.push({
            courseId: item.id,
            courseName: item.courseName,
            classroomId: item.classroomId,
            classroomName: item.classroomName,
            teacherId: item.teacherId,
            teacherName: item.teacherName,
            teacherNumber: item.teacherNumber,
            isSelect: false,
          });
        });
        // console.log("this.autoMaticCourseList:", this.autoMaticCourseList);
      });
    },
    // 自动排课点击重置
    reset() {
      this.schoolClassList.forEach((item) => {
        item.courseInfo = [];
      });
      this.autoMaticCourseList.forEach((item) => {
        item.isSelect = false;
      });
      // this.gradeValue = "";
      // this.schoolClassList = [];
    },
    // 获取学校课室列表
    getClassroomList() {
      let data = {
        schoolId: this.user.schoolId,
      };
      this.get(this.$url.getClassroomList, data).then((res) => {
        // console.log("获取学校课室列表==>", res);
        this.classroomList = res.rows;
      });
    },
    // 获取教师列表-自动排课重新编排
    async getTeacherList(e) {
      const res = await this.get(this.$url.selectTeacherClassList, {
        classId: e,
      });

      if (res.code === 200) {
        return res.data;
      } else {
        // 处理请求失败的情况
        return [];
      }
    },
    //点击重新编辑科目按钮，回到第一步
    setCourseListAgain(data) {
      // this.$emit("setCourseListAgain");
      this.$emit("changeEstablish", data.className);
    },
    // 智慧排课-年级选中切换
    async selectGrade(e) {
      this.gradeSelect = this.classSelectList.find((item) => {
        return item.gradeId == e;
      });

      this.schoolClassList = this.classSelectList.find((item) => {
        return item.gradeId == e;
      }).schoolClassList;

      // 切换年级重新获取当前年级的教师列表
      for (let item of this.schoolClassList) {
        item["teacherList"] = await this.getTeacherList(item.classId);
      }

      // 重置
      this.getCourseConstructionNum(e);
      this.getCoursePlanDailyMaxNum(e);
      this.selectCourseArrangeList();
      this.reset();
    },
    // 查看年级计划课节数量(最大课时，自动排课用)
    getCourseConstructionNum(gradeId) {
      this.courseConstructionNum = 0;
      let data = {
        gradeId,
      };
      this.get(this.$url.getCourseConstructionNum, data).then((res) => {
        // console.log("获取课程计划最大课时==>", res);
        if (res.code != 200) return this.$message.error(res.msg);
        if (res.data == 0 && this.classScheduleType == "智慧排课")
          return this.$message.warning("暂无课时，请前往课程计划设置！");
        this.courseConstructionNum = res.data;
      });
    },
    // 查看年级每天最大课节- 自动排课用
    getCoursePlanDailyMaxNum(gradeId) {
      this.coursePlanDailyMaxNum = 0;
      let data = {
        gradeId,
      };
      this.get(this.$url.getCoursePlanDailyMaxNum, data).then((res) => {
        // console.log("查看年级每天最大课节==>", res);
        if (res.code != 200) return this.$message.error(res.msg);
        this.coursePlanDailyMaxNum = res.data;
      });
    },
    // 课表类型切换
    classScheduleTypeSelect(e) {
      // console.log(e);
      // 获取我的课表数据
      if (e == "我的课表") {
        this.selectCourseArrangeByTeacher();
      }
      // 切换到智慧排课重新选中第一个班级
      if (e == "智慧排课") {
        this.gradeValue = this.classSelectList[0].gradeId;
        this.selectCourseArrangeList();
        this.getCourseConstructionNum(this.gradeValue);
      }
      this.classScheduleType = e;
      this.courseSelectList = [];
    },
    // 年级和班级选择列表
    selectSchoolAndGradeAndClassListPC() {
      this.get(this.$url.getgradeList, {
        schoolId: this.user.schoolId,
      })
        .then(async (res) => {
          if (res.code !== 200) {
            return this.$message.error(res.msg);
          }
          this.classSelectList = res.data;

          this.classSelectListLength = this.classSelectList.length;
          if (this.classSelectList.length) {
            // 自动排课需要用到的数据
            this.gradeValue = this.classSelectList[0].gradeId;
            this.gradeSelect = this.classSelectList[0];
            this.getCourseConstructionNum(this.classSelectList[0].gradeId);
            this.getCoursePlanDailyMaxNum(this.classSelectList[0].gradeId);
            this.schoolClassList = this.classSelectList.find((item) => {
              return item.gradeId == this.gradeValue;
            }).schoolClassList;

            for (let item of this.schoolClassList) {
              item["courseInfo"] = [];
              item["teacherList"] = await this.getTeacherList(item.classId);
            }

            // 手动排课用到的数据
            this.classSelectList.forEach((gItem, g) => {
              let { gradeCode, gradeId, gradeName } = gItem;
              gItem.value = {
                gradeCode,
                gradeId,
                gradeName,
              };
              gItem.label = gItem.gradeName;
              gItem.schoolClassList.forEach((cItem, c) => {
                let { classCode, classId, className } = cItem;
                cItem.courseInfo = [];
                cItem.value = {
                  classCode,
                  classId,
                  className,
                };
                cItem.label = cItem.className;
              });
            });
            this.classSelect = this.classSelectList;
            // console.log("this.classSelect:", this.classSelect);

            // 如果不是重新编排中的第三步，而是第一次打开手动排课
            if (this.previousLevelSubjectsList.length == 0) {
              // 默认第一个classId
              this.classId = this.classSelect[0].schoolClassList[0].classId;

              // 默认选中
              let firstGrade = {};
              let { gradeCode, gradeId, gradeName } = this.classSelect[0];
              firstGrade = { gradeCode, gradeId, gradeName };
              let firstClass = {};
              let { classCode, classId, className } =
                this.classSelect[0].schoolClassList[0];
              firstClass = { classCode, classId, className };
              this.className = [firstGrade, firstClass];
              this.classPlaceholder = `${firstGrade.gradeName} / ${firstClass.className}`;
              //获取课程表、科目模块数据
              this.selectCourseArrangeList();
              this.selectCourseArrangeListByClass();
            }
            // console.log("处理后的数据==>", this.classSelect);
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$message.error("获取班级列表失败");
        });
    },
    // 选择班级切换
    changeHandle(e) {
      // console.log("选中的班级==>", e);
      this.previousLevelSubjectsList = [];
      this.classId = e[1].classId;
      this.gradeValue = e[0].gradeId;
      this.selectCourseArrangeListByClass();
    },
    //返回随机颜色
    // generateRandomHexColor() {
    //   const randomColor = Math.floor(Math.random() * 16777215).toString(16);
    //   return `#${randomColor.padStart(6, "0")}`;
    // },
    generateRandomHexColor(index) {
      // const colorsArray = [
      //   "#5ebb54",
      //   "#7a0215",
      //   "#3c37c0",
      //   "#164bbe",
      //   "#02c349",
      //   "#80c38f",
      //   "#a0ad88",
      //   "#365475",
      //   "#000000",
      // ];
      const colorsArray = [
        "#92bcfe",
        "#ffa01a",
        "#51D76A",
        "#f789b4",
        "#1680FA",
        "#AA55FF",
        "#28D3B1",
        "#bc783b",
        "#000000",
        "fc3e39",
        "#5ebb54",
        "#7a0215",
        "#3c37c0",
        "#164bbe",
        "#02c349",
        "#80c38f",
        "#a0ad88",
        "#365475",
        "#02a2f8",
      ];

      // const randomIndex = Math.floor(Math.random() * colorsArray.length);
      return colorsArray[index];
    },
  },
};
</script>

<style scoped lang="scss">
@import "./curriculumManagement.scss";
</style>
